import React from 'react'
import { DataTable } from '@/shared/ui'
import type { Column, LedgerOperationDTO } from '@/shared/api'
import type { PaginationInfo } from '@/shared/ui'
import { formatMoney, operationReference } from './format'

interface Props {
  data: LedgerOperationDTO[]
  loading: boolean
  pagination?: (PaginationInfo & { onPageChange: (page: number) => void }) | undefined
  emptyMessage?: string
}

/** Журнал демо-баланса: тип операции, сумма, счёт/заказ и дата. */
export const OperationsTable: React.FC<Props> = ({
  data,
  loading,
  pagination,
  emptyMessage = 'Операций пока нет',
}) => {
  const columns: Column<LedgerOperationDTO>[] = [
    { key: 'entryTypeName', title: 'Тип' },
    {
      key: 'amount',
      title: 'Сумма',
      render: (_, operation) => formatMoney(operation.amount),
    },
    {
      key: 'invoiceId',
      title: 'Счёт/заказ',
      render: (_, operation) => operationReference(operation),
    },
    {
      key: 'createdAt',
      title: 'Дата',
      render: (_, operation) => operation.createdAt || '—',
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      loading={loading}
      emptyMessage={emptyMessage}
      pagination={pagination}
    />
  )
}
